import React, { FormEvent, useState } from "react";
import Button from "../../components/Button";
import { useNavigate } from "react-router-dom";
import InputField from "../../components/InputField";
import useFetch from "../../hooks/useFetch";
import { referralSignupApi } from "../../API/auth";
import { yupResolver } from "@hookform/resolvers/yup";
import { userSignUpSchema } from "../../validation/auth.validation";
import { useForm } from "react-hook-form";
import AuthLayout from "../../Layout/Auth/ReferralAuth";
import PasswordInput from "../../components/PasswordInput";
import { removeEmptyFields } from "../../Utils";

interface Creds {
  country: string;
  state: string;
  city: string;
  type: string;
  email: string;
  lastName: string;
  password: string;
  confirmPassword: string;
  firstName: string;
  phoneNumber: string;
}

const initialCreds = {
  email: "",
  city: "",
  state: "",
  country: "",
  password: "",
  lastName: "",
  firstName: "",
  phoneNumber: "",
  confirmPassword: "",
  type: "projectOwner",
};

export default function ReferralSignup() {
  const { isLoading, load } = useFetch();
  const [error, setError] = useState<string>();

  //
  const navigation = useNavigate();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<Creds>({
    reValidateMode: "onChange",
    defaultValues: initialCreds,
    resolver: yupResolver(userSignUpSchema({})),
  });

  const submitHandler = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    handleSubmit((creds) => {
      const payload: any = removeEmptyFields({
        ...creds,
        type: "projectOwner",
      });
      // if (!payload.city && payload.country === "United Kingdom")
      //   delete payload.city;
      if (creds.password !== creds.confirmPassword)
        return setError("Passwords should match");
      delete payload.confirmPassword;

      load(referralSignupApi(payload))
        .then(() => navigation(`/verification?email=${creds.email}`))
        .catch((er) => setError(er.message));
    })();
  };

  const Form = (
    <>
      <h1 className="md:text-center text-left font-DemiBold">
        Sign up to get control to your referrals!
      </h1>
      <div className="flex items-start md:flex-row flex-col md:justify-between w-full">
        <InputField
          label="First name"
          placeholder="First name"
          error={errors.firstName?.message}
          register={register("firstName")}
        />
        <div className={`spacer md:block hidden`} />
        <InputField
          label="Last name"
          placeholder="Last name"
          error={errors.lastName?.message}
          register={register("lastName")}
        />
      </div>
      <InputField
        label="Email address"
        register={register("email")}
        placeholder="e.g example@internet.com"
        error={errors.email?.message}
        type="email"
      />
      {/* <div className="flex items-start md:flex-row flex-col md:justify-between w-full">
        <SelectField
          showSearch
          value={country}
          label="Country"
          className="md:w-[48%]"
          error={errors.country?.message}
          isLoading={areCountriesLoading}
          placeholder="Select your country"
          onChange={(val) => handleChange("country", val)}
          data={countries}
        />
        <div className={`spacer md:block hidden`} />
        <SelectField
          showSearch
          value={state}
          disabled={!country}
          className="md:w-[48%]"
          label="State/Province"
          isLoading={areStateLoading}
          error={errors.state?.message}
          placeholder="Select your state / province"
          onChange={(val) => handleChange("state", val)}
          data={StatesRes?.states
            .map((one) => ({ value: one.name }))
            .sort((a, b) => a.value.localeCompare(b.value))}
        />
      </div> */}
      {/* 
      <div className="flex md:flex-row flex-col md:justify-between w-full">
        <SelectField
          showSearch
          label="City"
          value={city}
          disabled={!state}
          className="md:w-[48%]"
          isLoading={areCitiesLoading}
          error={errors.city?.message}
          placeholder="Select your city"
          onChange={(val) => handleChange("city", val)}
          data={cities
            ?.map((one) => ({ value: one }))
            .sort((a, b) => a.value.localeCompare(b.value))}
        />
        <div className={`spacer md:block hidden`} />
        <div className="md:w-[48%] flex flex-col justify-center items-start">
          <label className="capitalize text-bash text-sm mb-1">
            Phone number
          </label>
          <PhoneInput
            country={cca2}
            containerClass="w-full"
            value={watch("phoneNumber")}
            inputClass="!w-full !flex-1 !py-6 !border-bash"
            onChange={(phone) => handleChange("phoneNumber", phone)}
          />
          <p className={errorStyle}>{errors.phoneNumber?.message}</p>
        </div>
      </div> */}

      <PasswordInput
        label="Password"
        placeholder="••••••••••••"
        register={register("password")}
        error={errors.password?.message}
      />
      <PasswordInput
        label="Confirm Password"
        placeholder="••••••••••••"
        error={errors.password?.message}
        register={register("confirmPassword")}
      />
      {error ? (
        <div>
          <div className="halfSpacer" />
          <p className="error">{error}</p>
        </div>
      ) : (
        <div className="spacer" />
      )}
      <Button
        text="Sign Up"
        isLoading={isLoading}
        type={Object.keys(errors)[0] ? "muted" : "primary"}
      />
    </>
  );

  return (
    <AuthLayout
      {...{ Form, submitHandler }}
      footer={{
        labelQuestion: "Already have an account",
        labelActionDesc: "Sign in",
        link: "/signin",
      }}
    />
  );
}
